module.exports = __webpack_public_path__ + "static/media/w5.3fc71e3f.png";